import {AbstractFilterComponent} from "./abstract-filter-component.js";
import {FilterLabel} from "./components/label.js";

export class FilterSelectsRange extends AbstractFilterComponent {

	static selector = '.js-filter-selects-range';

	selectStart;
	selectEnd;

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.init();
	}

	init() {
		let self = this;
		let filter = self.node;

		let start = filter.querySelector('.js-filter-selects-range__start');
		start = start.nodeName === 'SELECT' ? start : start.querySelector('select');

		let end = filter.querySelector('.js-filter-selects-range__end');
		end = end.nodeName === 'SELECT' ? end : end.querySelector('select');

		if (! start || ! end) {
			return;
		}

		self.selectStart = start;
		self.selectEnd = end;

		['Start', 'End'].forEach(type => {
			let selector = self[`select${type}`];

			selector.addEventListener('change', function () {
				self.componentStateChanged();
			});
		});
	}

	getLabels() {
		let self = this;

		let selectedFirst = self.selectStart.selectedIndex === 0;
		let selectedLast = self.selectEnd.options.length - 1 === self.selectEnd.selectedIndex;

		if (selectedFirst && selectedLast) {
			return [];
		}

		let content = self.node.dataset.labelPattern;
		content = content.replace(/{start}/, self.selectStart.value);
		content = content.replace(/{end}/, self.selectEnd.value);

		return [
			new FilterLabel(self, content)
		];
	}

	labelDismissed() {
		let self = this;

		self.filter.setForceUpdateMode();
		self.selectStart.selectedIndex = 0;
		self.selectEnd.selectedIndex = self.selectEnd.options.length - 1;

		self.selectStart.dispatchEvent(new CustomEvent('change'));
		self.selectEnd.dispatchEvent(new CustomEvent('change'));
	}

	getFormData() {
		let self = this;

		let selectedFirst = self.selectStart.selectedIndex === 0;
		let selectedLast = self.selectEnd.options.length - 1 === self.selectEnd.selectedIndex;

		if (selectedFirst && selectedLast) {
			return [];
		}

		let result = {};
		result[self.selectStart.name] = self.selectStart.value;
		result[self.selectEnd.name] = self.selectEnd.value;

		return result;
	}
}
